import React from "react";

import LoginOrRegisterForm from "../components/LoginRegisterForm";

const LoginPage = () => {
  return <LoginOrRegisterForm loginOrRegister={"login"} />;
};

export default LoginPage;
